import { render, staticRenderFns } from "./SpendingPie.vue?vue&type=template&id=59747fda"
import script from "./SpendingPie.vue?vue&type=script&lang=js"
export * from "./SpendingPie.vue?vue&type=script&lang=js"
import style0 from "./SpendingPie.vue?vue&type=style&index=0&id=59747fda&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports